export default {
  loggedUser: (state) => state.loggedUser,
  isLoggedIn: (state) => {
    return state.loggedUser.token !== null
  },
  hasPermission: (state, rootState) => ({
    resource,
    operation = 'View'
  }) => {
    return (
      rootState.loggedUser.permissions.filter(x =>
        x.resource === resource && (x.operationsList.split(',').includes(operation) || x.operationsList === 'All')
      ).length === 1
    )
  },
  isRoutePublic: state => route => {
    // Using getters with extra arguments: https://goo.gl/7kQaiF
    return typeof route.meta.isPublic !== 'undefined'
  },
  menuItems: (state, rootState) => {
    let menuItems = [{
      name: 'Locations',
      route: '/location',
      description: 'Optional brief description.',
      icon: 'bank',
      showReportIcon: false,
      showAddIcon: true,
      isAdminOnly: true
    },
    {
      name: 'Users',
      route: '/user',
      description: 'Optional brief description.',
      icon: 'account-multiple',
      showReportIcon: false,
      showAddIcon: true,
      isAdminOnly: true
    },
    {
      name: 'Categories',
      route: '/category',
      description: 'Optional brief description.',
      icon: 'account-multiple',
      showReportIcon: false,
      showAddIcon: false,
      isSuperAdminOnly: true
    },
    {
      name: 'Videos',
      route: '/video',
      description: 'Optional brief description.',
      icon: 'account-multiple',
      showReportIcon: false,
      showAddIcon: true
    }
    ]

    switch (rootState.loggedUser.role) {
      case 'SuperAdmin':
        return menuItems
      case 'Admin':
        return menuItems.filter((x) => !x.isSuperAdminOnly)
      case 'User':
        return menuItems.filter((x) => !x.isAdminOnly && !x.isSuperAdminOnly)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js